module.exports = "<mat-sidenav-container>\n  <router-outlet></router-outlet>\n</mat-sidenav-container>\n"